"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var regex_1 = require("./utils/regex");

var dashRegex = /[ .]/g;
var percentRegex = /%/g;
/**
 * Makes the value safe for use in a class name.
 */

function getSafeValue(value) {
  return value.replace(dashRegex, '-').replace(percentRegex, 'prcnt').replace(regex_1.unsafeClassNameCharacters, '');
}

exports.default = getSafeValue;